import { Navigate, Outlet } from 'react-router';
import { useAppSelector } from '@/store';
import { selectIsSystemAdmin } from '@/store/Auth/authSelectors';

/**
 * RequireSystemAdmin - Route guard component
 *
 * Protects routes that should only be accessible to System Admin users (isSuper === true).
 * Non-system-admin users attempting to access protected routes will be redirected
 * to the tenant dashboard page (/terminal/dashboard).
 *
 * @example
 * // In router configuration
 * {
 *   path: '/os',
 *   element: <RequireSystemAdmin />,
 *   children: [
 *     // OS routes here
 *   ]
 * }
 */
export default function RequireSystemAdmin() {
  const isSystemAdmin = useAppSelector(selectIsSystemAdmin);

  if (!isSystemAdmin) {
    // Redirect non-system-admin users to tenant dashboard
    return <Navigate to='/terminal/dashboard' replace />;
  }

  return <Outlet />;
}
